import { useState } from 'react';
import { useNavigate } from 'react-router';
import { mutateConfig } from '../api/mutationConfig';
import { MerchantsDropdown } from '../components/MerchantsDropdown';

export const NewMerchantTransaction = () => {
  const navigate = useNavigate();
  const { mutate: createTransaction, isPending } = mutateConfig()<void>({
    url: '/v1/ops/merchant/topup',
  });

  const [merchantUid, setMerchantUid] = useState('');
  const [amount, setAmount] = useState<number>(0);
  const [displayAmount, setDisplayAmount] = useState('');

  const isValid = merchantUid !== '' && amount > 0;

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    const parts = raw.split('.');
    const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formatted = parts.length > 1 ? `${integer}.${parts[1]}` : integer;
    setDisplayAmount(formatted);
    setAmount(raw === '' ? 0 : Number(raw));
  };

  const handleSubmit = (e: { preventDefault(): void }) => {
    e.preventDefault();
    createTransaction(
      {
        merchant_uid: merchantUid,
        amount: Math.round(amount * 100),
      },
      { onSuccess: () => navigate('/transactions') }
    );
  };

  return (
    <div className="flex flex-col gap-6 max-w-lg">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/transactions')}
          className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
        >
          ← Back
        </button>
        <h1 className="text-xl font-semibold text-gray-900">Merchant Topup</h1>
      </div>
      <div className="bg-white rounded-2xl border border-gray-200 p-6">
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Merchant</label>
            <MerchantsDropdown value={merchantUid} onChange={setMerchantUid} />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Amount</label>
            <input
              name="amount"
              type="text"
              inputMode="decimal"
              value={displayAmount}
              onChange={handleAmountChange}
              placeholder="0"
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
            />
          </div>
          <button
            type="submit"
            disabled={!isValid || isPending}
            className="w-full py-2 px-4 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {isPending ? 'Saving...' : 'Topup Merchant'}
          </button>
        </form>
      </div>
    </div>
  );
};
